import { Component } from 'react';
import PropTypes from 'prop-types';
import { clickManagerContext } from '../../util/contextNamespace';
export default class DropdownItemClickManager extends Component {
    constructor() {
        super(...arguments);
        this.handleItemClicked = (event) => {
            this.props.onItemClicked(event);
        };
    }
    getChildContext() {
        return {
            [clickManagerContext]: {
                itemClicked: this.handleItemClicked,
            },
        };
    }
    render() {
        return this.props.children;
    }
}
DropdownItemClickManager.childContextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    [clickManagerContext]: PropTypes.object,
};
//# sourceMappingURL=DropdownItemClickManager.js.map